:host,
:host picture,
:host img {
  display: block;
  max-width: 100%;

  &.full-width {
    width: 100%;
  }

  &.background-cover {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;

    &,
    img {
      width: 100%;
      height: 100%;
      border-radius: var(--wink-image-border-radius, var-rem(--semantic-radius-none));
      object-fit: cover;
    }
  }

  &.aspect-ratio {
    @include media('from-lg') {
      &--lg {
        &-square {
          position: relative;
          aspect-ratio: 1/1;
        }

        &-landscape {
          position: relative;
          aspect-ratio: 16/9;
        }

        &-portrait {
          position: relative;
          aspect-ratio: 9/16;
        }
      }
    }
    @include media('md-lg') {
      &--md {
        &-square {
          position: relative;
          aspect-ratio: 1/1;
        }

        &-landscape {
          position: relative;
          aspect-ratio: 16/9;
        }

        &-portrait {
          position: relative;
          aspect-ratio: 9/16;
        }
      }
    }
    @include media('until-md') {
      &--sm {
        &-square {
          position: relative;
          aspect-ratio: 1/1;
        }

        &-landscape {
          position: relative;
          aspect-ratio: 16/9;
        }

        &-portrait {
          position: relative;
          aspect-ratio: 9/16;
        }
      }
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &.wink-banner-image {
    position: relative;
    height: 100%;

    picture {
      overflow: hidden;
      max-height: 100%;

      &.aspect-ratio {
        height: 100%;
      }
    }
  }
}
